module.exports = __webpack_public_path__ + "img/天王.8f563e25.svg";